<template>
    <span>
        <template v-if="value">
            <span class="blue--text" v-if="value.priceDiff == 0 && value.price > 0 && (value.realPrice == 0 || value.realPrice == null)">
                {{ value.price | euro }}
            </span>
            <span class="red--text" v-else-if="value.priceDiff > 0">
                {{ value.realPrice | euro }} (+{{ value.priceDiff | euro }})
            </span>
            <span class="green--text" v-else> 
                {{ value.realPrice | euro }} ({{ value.priceDiff | euro }})
            </span>
        </template>
    </span>
</template>
<script>
export default {
    props: {
        value: { type: Object, required: true },///PriceInfo {price:float, realPrice:float, priceDiff:float}
    }
}
</script>